import * as types from '../actions/types';

const initialState = {
  useCoupon: null,
  isError: false,
  isRefresh: false
};

const useCouponReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USE_COUPON_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.USE_COUPON_SUCCEEDED:
      return {
        ...state,
        useCoupon: action.data,
        error: null
      };
    case types.USE_COUPON_FAILED:
      return {
        ...state,
        isError: true,
        useCoupon: null,
        error: action.error
      };
    case types.EXCHANGE_COUPON_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.EXCHANGE_COUPON_SUCCEDDED:
      return {
        ...state,
        useCoupon: action.data,
        error: null
      };
    case types.EXCHANGE_COUPON_FAILED:
      return {
        ...state,
        isError: true,
        useCoupon: null,
        error: action.error
      };
    case types.HIDE_ERROR:
      return {
        ...state,
        isError: false
      };
    default:
      return state;
  }
};

export default useCouponReducer;
